import React, { useContext } from "react";
import PropTypes from "prop-types";
import NotifyContext from "context/NotifyContext";
import { Button, Icon, Alert } from "components";
import styles from "styles/notifications.module.scss";
import useReactRouter from "use-react-router";
import _ from "lodash";
import classNames from "lib/classNames";

const Notifications = () => {
  const { state: notifications } = useContext(NotifyContext);
  const { history } = useReactRouter();
  const uniqNotifications = _.uniqBy(Object.values(notifications), "id").filter(
    ({ exclude = [], only = [] }) => {
      if (exclude.length && exclude.includes(history.location.pathname))
        return false;
      if (only.length && !only.includes(history.location.pathname))
        return false;
      return true;
    }
  );
  return !!uniqNotifications.length ? (
    <div className={classNames("px-6 pt-6")}>
      {uniqNotifications.map((notification, index) => (
        <Notification key={index} {...notification} />
      ))}
    </div>
  ) : null;
};

Notifications.propTypes = {};

const Notification = ({
  type,
  icon,
  title,
  content = null,
  action = null,
  closeable = true
}) => {
  const icons = {
    info: "info-square",
    warning: "exclamation-square"
  };
  return (
    <Alert
      {...{ type, title, closeable, icon, className: "mb-2" }}
      actions={action ? [action] : []}
    >
      {!!content && <p>{content}</p>}
    </Alert>
  );
};

export default Notifications;
